import { Text } from "components/common/Text";
import { componentConfig } from "config/theme";

type CategoryTabOption<T extends string> = {
  id: T;
  label: string;
};

type CategoryTabsProps<T extends string> = {
  tabs: CategoryTabOption<T>[];
  selectedCategory: T;
  onSelectCategory: (category: T) => void;
};

export const CategoryTabs = <T extends string>({
  tabs,
  selectedCategory,
  onSelectCategory,
}: CategoryTabsProps<T>) => {
  return (
    <div className="mb-[1vw] flex gap-[1vw] flex-nowrap justify-start overflow-x-auto whitespace-nowrap border-b-2 px-[2vw] py-0 border-border">
      {tabs.map((tab) => {
        const isActive = selectedCategory === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={`flex-shrink-0 border-b-2 border-transparent px-[1.2vw] py-[0.5vw] transition-colors ${
              isActive
                ? componentConfig.categoryTabsActiveClass
                : componentConfig.categoryTabsInactiveClass
            }`}
            onClick={() => onSelectCategory(tab.id)}
            data-testid={`cat-tab-${tab.id}`}
          >
            <Text
              as="span"
              variant="categoryTabLabel"
              className="font-semibold"
            >
              {tab.label}
            </Text>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryTabs;
